// Slightly rushed as internal launch is next day.
// TODO: Clean this up, comment code.

export default {
  init() {
    // JavaScript to be fired on the home page
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
    const $categoriesMobileWrap = $('.component-categories-mobile-wrap');
    $categoriesMobileWrap.css({ 'height': $(window).innerHeight() + 'px' });

    $('.categories-btn-mob').on('click', function() {
      // Open categories sidebar
      $categoriesMobileWrap.addClass('show');
      $('body').addClass('overflow-hidden');
    });

    $categoriesMobileWrap.find('.wrap-close').on('click', function() {
      // Close categories sidebar
      $categoriesMobileWrap.removeClass('show');
      $('body').removeClass('overflow-hidden');
    });

    $categoriesMobileWrap.find('.update-results-btn').on('click', function() {
      // Execute search
      // const searchPath = $categoriesMobileWrap.find('.wrap-term.active').data('link');
      // window.location = searchPath;
      $('#category-form').submit();
    });

    /**
     * Category filters (Desktop)
     */
    $('.update-btn').on('click', function() {
      $('#category-form').submit();
    });

    function updateFiltersFrontend() {
      $('#category-form input[name="tax[]"]').each(function() {
        const catId = $(this).val();
        const checked = $(this).attr('checked');
        var indeterminate = false;

        if ($(this).data('has-children')) {
          const $children = $(`#category-form input[name="tax[]"][data-parent-id="${catId}"]`);

          var allUnchecked = true;
          var allChecked = true;

          $children.each(function() {
            if (!$(this).attr('checked')) {
              allChecked = false;
            } else {
              allUnchecked = false;
            }
          });

          if (!allChecked && !allUnchecked) {
            indeterminate = true;
          }

          if (!allUnchecked) {
            $(`.categories-wrap .item-checkbox[data-cat-id="${catId}"]`).parents('.resource-category-item').addClass('expanded');
          }
        }

        if (checked) {
          $(`.categories-wrap .item-checkbox[data-cat-id="${catId}"]`).addClass('checked');
        } else {
          $(`.categories-wrap .item-checkbox[data-cat-id="${catId}"]`).removeClass('checked');
        }

        if (indeterminate) {
          $(`.categories-wrap .item-checkbox[data-cat-id="${catId}"]`).addClass('indeterminate');
        } else {
          $(`.categories-wrap .item-checkbox[data-cat-id="${catId}"]`).removeClass('indeterminate');
        }
      });
    }

    updateFiltersFrontend();

    $('.resource-category-item').each(function() {
      const $categoryItem = $(this);

      $(this).find('.item-checkbox').on('click', function() {
        const catId = $(this).data('cat-id');
        const $selectBox = $(`#category-form input[name="tax[]"][value="${catId}"]`);

        $selectBox.attr('checked', !$selectBox.attr('checked'));
        $selectBox.trigger('change');

        if ($selectBox.attr('checked')) {
          $categoryItem.addClass('expanded');
        }
      });

      $(this).find('.expander-toggle').on('click', function(e) {
        if ($(e.target).parents('.item-checkbox').length == 0) {
          $categoryItem.toggleClass('expanded');
        }
      });
    });

    $('#category-form input').each(function() {
      $(this).on('change', function() {
        if ($(this).data('has-children')) {
          // All children must be checked, or unchecked.
          const isChecked = Boolean($(this).attr('checked'));
          const thisId = $(this).attr('value');
          $(`#category-form input[name="tax[]"][data-parent-id="${thisId}"]`).attr('checked', isChecked);
        }

        if ($(this).data('parent-id')) {
          // This is a child item.
          const parentId = $(this).data('parent-id');
          const $allChildren = $(`#category-form input[name="tax[]"][data-parent-id="${parentId}"]`);

          var allChecked = true;
          var allUnchecked = true;

          $allChildren.each(function() {
            if ($(this).attr('checked')) {
              allUnchecked = false;
            } else {
              allChecked = false;
            }
          });

          if (allChecked) {
            // Check the parent
            $(`#category-form input[name="tax[]"][value="${parentId}"]`).attr('checked', true);
          }
          
          if (allUnchecked) {
            // Uncheck the parent
            $(`#category-form input[name="tax[]"][value="${parentId}"]`).attr('checked', false);
          }
        }

        updateFiltersFrontend();
      });
    });

    /**
     * Auto-scroll to main content if filters are added
     */
    if ($('a[name="skip-content"]').length > 0) {
      window.scrollTo(0, $('a[name="skip-content"]').offset().top);
    }

    const searchForm = document.querySelector('#SearchForm');
    const formButton = document.querySelector('#SubmitButton');

    formButton.addEventListener('click', function(){
      searchForm.submit();
    });
  },
}


// WEBPACK FOOTER //
// ./scripts/routes/templateResources.js